<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="导出-自定义文件名称"
        width="750px"
        append-to-body
        :before-close="handleClose">

        <div class="content">
            <el-form ref="form" :rules="rules" :model="formItem" @submit.native.prevent label-width="120px" class="pr60">
                <el-form-item label="文件名称：" prop="name" class="label-required">
                    <el-input
                        v-model.trim="formItem.name"
                        ref="nameInput"
                        maxlength="100"
                        show-word-limit
                        @keyup.enter.native.prevent.stop="handleSubmit"
                        placeholder="请输入文件名称"
                        class="word-limit-input"></el-input>
                </el-form-item>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">导出</el-button>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "ExportModal",
        components:{

        },
        props:{
            name:String,
        },
        data() {
            return {
                submitLoading:false,
                dialogVisible: false,
                formItem:{
                    name:'',
                },
                rules:{
                    name:[
                        {required: true, message: '请输入文件名称', trigger: 'blur'},
                        {max: 100, message: '最多100个字', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            handleClose() {
                console.log('handleClose');
                this.dialogVisible = false;
                this.submitLoading = false;
                this.resetForm();
                this.$emit('close');
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    this.resetForm();
                    this.formItem.name = this.name;
                })
            },
            resetForm(){
                this.formItem.name = '';
                this.$refs.form.resetFields();
            },
            hideModal(){
                this.dialogVisible = false;
                this.submitLoading = false;
                this.resetForm();
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.$emit('submit',this.formItem.name);
                        this.submitLoading = true;
                    } else {
                        return false;
                    }
                });

            },
        }
    }
</script>

<style scoped>
    .action-btn {
        width: 120px;
    }

    ::v-deep .word-limit-input .el-input__suffix{
        right: -50px;
    }
</style>
